import Api from 'api/v2/Api';

const basePath = '/api/v2/applications';

export class SsoApi extends Api {
  async fetch(id) {
    const { data: sso } = await this.axios.get(`${basePath}/${id}/sso`);

    return sso;
  }

  async delete(id) {
    await this.axios.delete(`${basePath}/${id}/sso`);
  }

  async save(id, sso) {
    const { data: savedSso } = await this.axios.post(`${basePath}/${id}/sso`, sso);

    return savedSso;
  }

  async update(id, sso) {
    const { data: savedSso } = await this.axios.put(`${basePath}/${id}/sso`, sso);

    return savedSso;
  }
}

export default new SsoApi();
